var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineItemsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M424.415,367.592l10.368-17.264l-25.111-25.104L392.4,335.592l-9.76-4.023L377.752,312h-9.753v32.641 c27.089,3.903,48,27.207,48,55.359c0,30.88-25.128,56-56,56c-30.871,0-56-25.12-56-56c0-2.68,0.305-5.344,0.696-8H272v25.752 l19.616,4.896l3.968,9.743l-10.368,17.28l25.111,25.104l17.272-10.368l9.76,4.023L342.247,488h35.505l4.888-19.568l9.76-4.023 l17.272,10.368l25.111-25.104l-10.368-17.28l3.721-9.136l4.271-1.616L448,417.752v-35.504l-19.616-4.896L424.415,367.592z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M128,344h48v32h-48V344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M128,296h48v32h-48V296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M192,296h160v32H192V296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M360,424c-13.232,0-24-10.768-24-24c0-2.816,0.575-5.488,1.472-8H320.92c-0.553,2.656-0.921,5.328-0.921,8 c0,22.056,17.944,40,40,40c22.057,0,40-17.944,40-40c0-19.313-13.768-35.473-32-39.191v16.664c9.288,3.312,16,12.111,16,22.527 C383.999,413.232,373.232,424,360,424L360,424z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1E6EC0",
    cx: 360,
    cy: 400,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M192,344h160v32H192V344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M264,184h48v48h-48V184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M328,232h160v-48H328V232z M456,200h16v16h-16V200z M424,200h16v16h-16V200z M392,200h16v16h-16V200z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M224,408h16v16h-16V408z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M192,408h16v16h-16V408z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M24,384V240c0-13.232,10.768-24,24-24h104v36.944L241.888,208L152,163.056V200H48 c-22.057,0-40,17.944-40,40v144c0,22.057,17.943,40,40,40h128v-16H48C34.768,408,24,397.232,24,384z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M136,24h160v32H136V24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M72,24h48v32H72V24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M136,72h160v32H136V72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M72,72h48v32H72V72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M328,56h16v16h-16V56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M440,80v24h-32l40,53.336L488,104h-32V80c0-13.232-10.769-24-24-24h-72v16h72C436.415,72,440,75.592,440,80 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineItemsIcon);
export default __webpack_public_path__ + "static/media/line-items-icon.83127b2f6684a6d81b1b570f2b28bd55.svg";
export { ForwardRef as ReactComponent };